__webpack_require__.p = "https://match-the-room-gamma.ambient.amazon/";